import { createAppTestIds } from './index';

/**
 * Test IDs for Hubspot CRM integration
 */
export const HUBSPOT_TEST_IDS = {
  ...createAppTestIds('hubspot'),

  // Manage modals
  memberManageModal: 'hubspot-member-manage-modal',
  teamManageModal: 'hubspot-team-manage-modal',

  // CRM Autofill settings
  autofill: {
    section: 'hubspot-autofill-section',
    enableToggle: 'hubspot-autofill-enable-toggle',
    fieldMapping: 'hubspot-autofill-field-mapping',
    /**
     * Get test-id for a specific field mapping row
     */
    fieldRow: (fieldName: string) => `hubspot-autofill-field-${fieldName}`,
  },

  // Config rows
  configRow: (index: number) => `hubspot-config-row-${index}`,
} as const;
